import { memo } from "react";
import { CloseIcon } from "../../services/icons";
import "./PreviewFiles.css";

const FileView = memo(function FileView({ file }) {
	const fileType = fileTypeFromBase64(file);
	if (["jpeg", "png", "gif", "webp", "bmp", "jpg", "svg"].includes(fileType)) {
		return <img src={file} alt={"preview"} className="preview--img" />;
	} else if (["pdf"].includes(fileType)) {
		return <object data={file} type="application/pdf" width="100%" height="150px" className="preview--pdf"></object>;
	} else {
		return <div style={{ padding: "20px", textAlign: "center" }}>File type not supported for preview.</div>;
	}
});
export default function PreviewFiles({ files, onClose }) {
	return (
		<div className="preview">
			<div className="preview--head">Preview</div>
			<div className="preview--body">
				{files.map((f, index) => (
					<div key={index} className="preview--item">
						<CloseIcon
							className="preview--close"
							fontSize="1.5rem"
							onClick={(e) => {
								e.stopPropagation();
								onClose(index);
							}}
						/>
						<FileView file={f} />
					</div>
				))}
			</div>
		</div>
	);
}

function fileTypeFromBase64(base64) {
	const matches = base64?.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/) || [];
	if (matches.length === 3) {
		const contentType = matches[1];
		return contentType.split("/")[1];
	} else {
		return "unknown";
	}
}
